import React from 'react';
import { RegularButton } from 'fronton-react';
import type { CarouselControlProps } from './types';
import { controlStyles } from './styles';
import { getAriaLabelFromDirection } from './utils';
import { DirectionIcon } from './direction-icon';

export const CarouselControlButton = ({ direction = 'left', onClick, ...props }: CarouselControlProps) => {
  return (
    <RegularButton
      className={controlStyles}
      aria-label={getAriaLabelFromDirection(direction)}
      iconOnly
      rounded
      size="l"
      variant="primary"
      invert
      onClick={onClick}
      {...props}>
      <DirectionIcon direction={direction} />
    </RegularButton>
  );
};
